// ui
import {Card, Image, Loader, LoadingOverlay} from '@mantine/core';
import styles from './styles.module.scss';

// next
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentGame } from '@/store/features/gameSlice';
import { gameClicked } from "@/utils/event";
import { cloneDeep } from "@/tools/self_lodash";

export default function GameSimilar({ gameList, loading }) {
    const router = useRouter();
    const dispatch = useDispatch();
    const { isMobile } = useSelector((state) => state.game);

    const handleGameClick = (game) => {
        // 记录游戏的点击
        let cloneGame = cloneDeep(game);
        gameClicked({path: cloneGame.path});
        // 保存当前游戏数据到Redux
        dispatch(setCurrentGame({...cloneGame, clicked_count: cloneGame.clicked_count + 1}));
        // 跳转到游戏详情页，并带上参数
        router.push({
            pathname: `/game/${cloneGame.path}`,
        });

        if (isMobile) {
            document.body.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    if (loading) {
        return (
            <div className={styles.container}>
                <div className={`${styles.grid_container} ${styles.loading}`}>
                    <LoadingOverlay
                        visible={true}
                        zIndex={2000}
                        overlayProps={{ radius: 'md', opacity: 0.1 }}
                        loaderProps={{ color: 'white', type: 'bars' }}
                    />
                </div>
                
            </div>
        )
    }

    if (!gameList.length) {
        return (
            <div className={styles.empty_content}>
                <div className={styles.image_wrapper}>
                    <Image
                        src="/images/icons/common/404.png"
                        alt="404 Error"
                        width={600}
                        height={200}
                        className={styles.error_image}
                    />
                    <div className={styles.remind}>
                        No Data
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={styles.container}>
            <div className={styles.grid_container}>
                {gameList.map((game) => (
                    <a
                        key={`${game.id}_${game.name}`}
                        title={game.name}
                        href={'/game/' + game.path}
                        onClick={(e) => {
                            // 只阻止直接点击，允许其他鼠标事件（如右键菜单）
                            if (e.button === 0 && !e.ctrlKey && !e.metaKey) {
                                e.preventDefault();
                                handleGameClick(game);
                            }
                        }}
                    >
                        <Card
                            key={game.id}
                            className={`${styles.card} ${styles[game.id]}`}
                            shadow="sm"
                            padding={0}
                            radius="md"
                        >
                            <Card.Section className={styles.card_section}>
                                { !game.loading ?
                                    <>
                                        <Image
                                            src={game.cover_image}
                                            alt={`Game ${game.name}`}
                                            className={styles.image}
                                        />
                                    </>
                                    : <div className={styles.cover_loader}>
                                        <Loader color="blue"/>
                                    </div> }
                                <div className={`${styles.image_name} styles.font_light`}>
                                    {game.name}
                                </div>
                            </Card.Section>
                        </Card>
                    </a>
                ))}
            </div>
        </div>
    );
}
